import { extend, override } from "flarum/common/extend";
import avatar from "flarum/common/helpers/avatar";
import username from "flarum/common/helpers/username";
import Link from "flarum/common/components/Link";
import UserPage from "flarum/components/UserPage";

export default function ({ components }) {
  // console.log(flarum.extensions);
  const { SmallUserCard, UserDirectoryPage } = components;
  extend(SmallUserCard.prototype, "infoItems", function (items) {
    const user = this.attrs.user;
    const rank = String(user.data.attributes.AdvPoints);
    // const rank =
    //   user.data.attributes.discussionCount * 2 +
    //   user.data.attributes.commentCount;

    if (!!user) {
      items.add("rank", <span>{`Профессионализм: ${rank}`}</span>);
    }
  });


  extend(UserPage.prototype, "view", function (vnode) {
    const title = "Самые активные за сутки";
    const { lastDayActivity } = app.forum.data.attributes;
    if (!lastDayActivity) return;

    const topLastDayUsers = Object.entries(lastDayActivity)
      .map((e) => e[1])
      .slice(0, 11);

    const notLoadedUsers = topLastDayUsers
      .filter(({ user_id }) => {
        const user = app.store.getById('users', user_id);
        return !user;
      });
    const hasNotLoadedUsers = notLoadedUsers.length > 0;

    if (hasNotLoadedUsers) {
      Promise.all(
        notLoadedUsers.map(({ user_id }) => {
          this.loading = true;
          return app.store.find("users", user_id)
        })
      ).then((r) => {
        r.map(({ data }) => app.store.pushObject(data));
        this.loading = false;
         // m.redraw();
      });
    }

    const childElems = (
      <ul>
        <li className="topUsersActivityCard-title">
          <div className="topQuestionsTitle">
            {title}
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          </div>
        </li>
        {topLastDayUsers.map(({ user_id, answers, questions }) => {
          const user = app.store.getById("users", user_id);
          // console.log(user);
          if (!user) return;
          return (
            <li className="topUsersActivityCard">
              <div className="topUsersAwa">
                {avatar(user)}
                <div>
                  <Link href={app.route.user(user)}>{username(user)}</Link>
                  <div className="userActivityAnswers">
                    {"Ответов: "}
                    {!!answers ? answers : "0"}
                  </div>
                  {/*<div className="userActivityQuestions">
                    {"Вопросов: "}
                    {!!questions ? questions : "0"}
                  </div>*/}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    );

    // vnode.children.push(m("nav.AdvDiscusUserProfileWidjet", childElems));
    // vnode.children[1].children.push(m("nav.AdvDiscusUserProfileWidjet", childElems));
      if(vnode.children[1]) {
        // console.log(vnode.children[1].children);
        vnode.children[1].children.push(m("nav.AdvDiscusUserProfileWidjet", childElems));
      }

  });
  extend(UserDirectoryPage.prototype, "view", function (vnode) {
    const title = "Самые активные за сутки";
    const { lastDayActivity } = app.forum.data.attributes;
    if (!lastDayActivity) return;

    const topLastDayUsers = Object.entries(lastDayActivity)
      .map((e) => e[1])
      .slice(0, 11);

    // console.log(lastDayActivity, topLastDayUsers);
    const notLoadedUsers = topLastDayUsers
      .filter(({ user_id }) => {
        const user = app.store.getById('users', user_id);
        return !user;
      });
    const hasNotLoadedUsers = notLoadedUsers.length > 0;

    if (hasNotLoadedUsers) {
      Promise.all(
        notLoadedUsers.map(({ user_id }) => {
          this.loading = true;
          return app.store.find("users", user_id)
        })
      ).then((r) => {
        r.map(({ data }) => app.store.pushObject(data));
        this.loading = false;
         // m.redraw();
      });
    }

    const childElems = (
      <ul>
        <li className="topUsersActivityCard-title">
          <div className="topQuestionsTitle">
            {title}
            <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
          </div>
        </li>
        {topLastDayUsers.map(({ user_id, answers, questions }) => {
          const user = app.store.getById("users", user_id);
          if (!user) return;
          return (
            <li className="topUsersActivityCard">
              <div className="topUsersAwa">
                {avatar(user)}
                <div>
                  <Link href={app.route.user(user)}>{username(user)}</Link>
                  <div className="userActivityAnswers">
                    {"Ответов: "}
                    {!!answers ? answers : "0"}
                  </div>
                  {/*<div className="userActivityQuestions">
                    {"Вопросов: "}
                    {!!questions ? questions : "0"}
                  </div>*/}
                </div>
              </div>
            </li>
          );
        })}
      </ul>
    );
    // console.log(vnode.children[1]);
    const elemToUpdate = vnode.children[1];
    elemToUpdate.attrs.style = {display: 'flex'};
    // console.log( elemToUpdate);
    elemToUpdate.children.push(m("nav.AdvDiscusUserDirWidjet", childElems));
  });
}
